import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LiveWalkthroughTopbar({
  title,
  backTo,
  backLabel,
}: {
  title: string;
  backTo: string;
  backLabel: string;
}) {
  return (
    <header className="flex h-11 shrink-0 items-center gap-3 border-b border-border/60 bg-background px-4">
      <Link
        to={backTo}
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        <span>{backLabel}</span>
      </Link>
      {title && (
        <>
          <span className="text-muted-foreground" aria-hidden="true">
            /
          </span>
          <span className="truncate text-sm font-medium text-foreground">
            {title}
          </span>
        </>
      )}
    </header>
  );
}
